import { render, staticRenderFns } from "./BuyerInfoCard.vue?vue&type=template&id=05827bce&scoped=true&"
import script from "./BuyerInfoCard.vue?vue&type=script&lang=js&"
export * from "./BuyerInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./BuyerInfoCard.vue?vue&type=style&index=0&id=05827bce&lang=scss&scoped=true&"
import style1 from "./BuyerInfoCard.vue?vue&type=style&index=1&id=05827bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05827bce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
